import React from "react";
import {
  Backdrop,
  CircularProgress,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    flexDirection: "column", // stack vertically
    display: "flex",
  },
  message: {
    marginTop: theme.spacing(2.5),
  },
}));

export default function SimpleBackdrop({ message }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
      {message && (
        <Typography variant="h6" className={classes.message}>
          {message}
        </Typography>
      )}
    </Backdrop>
  );
}
